<template>
    <div class="habit-page">
        <div class="row mt-2">
            <div class="col-lg-8 col-8 mx-auto">
                <div class="small-box bg-warning card d-flex flex-row justify-content-between">
                    <h4 class="p-2" >Manage Movements:</h4>
                                        <!-- <div class="table table-dark table-striped" style="width: 70%;margin:auto;padding: .5em;"> -->
                    <select class="p-2" style="margin:.5em;" @change="displayModal($event.target.value)"  >
                        <option value="" >Select a Movement</option>
                        <option v-for="movement in allmovements" :key="movement.id" :value="movement.id" v-html="movement.movementname"></option>
                    </select>
                    <div v-if="allmovements.length<1">
<h3>No Movements found</h3>



                    </div>

                </div>

   <div class="small-box bg-warning card d-flex flex-row justify-content-between">
                    <h4 class="p-2" >BodyParts:</h4>
                                        <!-- <div class="table table-dark table-striped" style="width: 70%;margin:auto;padding: .5em;"> -->
                    <select class="p-2" style="margin:.5em;" @change="displayModal($event.target.value)"  >
                        <option value="" >Select a BodyPart</option>
                        <option v-for="bodypart in allBodyParts" :key="bodypart.id" :value="bodypart.id" v-html="bodypart.name"></option>
                    </select>
                    <div v-if="allmovements.length<1">
<h3>No Movements found</h3>



                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios';
import Swal from 'sweetalert2';
var _ = require('lodash');
import { v4 as uuidv4 } from 'uuid';
import EventBus from '../../../event-bus';


export default {
    components: {

     },
    name: "MovementManagement",
    data() {
        return {
            token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            loading: false,
            errors: {
                header: '',
                hc_add: '',
            },
            allmovements:[],
            userinfo:'',
            movement:'',
            BodyParts:'',
            currMovement: '',



        }
    },

    props: {
        userdata:'',
        movements:'',
        bodyparts:'',

    },
    mounted() {
        this.userinfo = JSON.parse(this.userdata);
        this.allmovements = JSON.parse(this.movements);
  this.allBodyParts = JSON.parse(this.bodyparts);
    },

    methods: {

        saveMovement() {
            console.log(this.movement);
            axios.post('/workout/movement/save', {
                user_id:this.userinfo.id,
                movement: this.movement
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                // this.myFSDetails= JSON.parse(res.data.fsdetails);
                this.cancelPerf();
                console.error(res.data.message);
            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                console.error(err);
            })
            .finally(()=> {
                // location.reload();
                  this.updateToast(this.message, 4000);
                this.message = '';
            });
        },
        gradeMyPerformance() {
            this.grading = true;
        },
        exitToDash() {
            location.replace('/fself/')
        },
        viewPerfTrack() {
            location.replace('/fself/reporting')
        },
        /**
        * @param {null}
        * @return {String} guid
        */
        getGUID() {
            var guid = uuidv4();
            console.log("GUID: " + guid);
            return guid;
        },
        displayModal(val) {
            if(val != '') {
                const payload = {
                life_area: val,
                }
                EventBus.$emit('populateModal', payload);
            }
        },

        displayModal2(id) {
            var model = this.getFSDetailsModel(id);
                const payload = {
                    model: model,
                }
            EventBus.$emit('populateModal2', payload);
        },
        getFSDetailsModel(id) {
            return this.myFSDetails.find((fsDet)=>{
                return fsDet.id == id;
            });
        },
        editFSDetails(id) {
            this.displayModal2(id);
        },
        todoLifeAreas() {
            var fsAreasWithout = [];
            var allLifeAreas = '';
            var myFSLifeDetailsAreas = this.myFSDetails.map((myd) => { return myd.life_area});
            //  console.log(myFSLifeDetailsAreas);
            allLifeAreas = this.alltemplates.map((templ)=>{
                // console.error(templ.life_area);
                (!myFSLifeDetailsAreas.includes(templ.life_area))? fsAreasWithout.push(templ.life_area):'';
                return templ.life_area;
            });
            // console.log(fsAreasWithout);
            // console.log(allLifeAreas);
            return fsAreasWithout;
        },
        doubleConfirmSwal(life_area) {
            Swal.fire({
            title: 'Do you want to delete this LifeArea Vision?',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Delete',
            denyButtonText: `Don't delete`,
            }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
            Swal.fire('Deleting....', '', 'success');
                console.log("Deleting for user: " + this.userinfo.id + " life-area vision: "+ life_area);
                this.deleteLifeArea(this.userinfo.id, life_area);
            } else if (result.isDenied) {
            Swal.fire('This LifeArea vision was not deleted', '', 'info')
            }
            });
        },
        deleteLifeArea(user_id, life_area){

             axios.post('/fself/components/delete', {
                user_id:user_id,
                life_area:life_area,
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                this.myFSDetails= JSON.parse(res.data.fsdetails);

                console.error(res.data.message);
            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                console.error(err.message);

            })
            .finally(()=> {
                // location.reload();
                  this.updateToast(this.message, 4000);

            });
        },
        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },

    }
}
</script>

<style scoped>


</style>
